module.exports = __webpack_public_path__ + "img/33.cda97221.png";